module.exports = __webpack_public_path__ + "media/images/icons/material/linkedin-c01382aed5c1216e911a4c53542cee49.svg";